
import React from "react";

interface CounterProps {
  end: number;
  suffix: string;
  title: string;
}

const TocFotosCounter: React.FC<CounterProps> = ({ 
  end, 
  suffix, 
  title
}) => {
  return (
    <div className="text-center">
      <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FF5605] mb-2">
        {end}{suffix}
      </div>
      <p className="text-[#261E13]/80 font-medium">{title}</p>
    </div>
  );
};

export default TocFotosCounter;
